import { produce, type WritableDraft } from "immer";
import { create } from "zustand";
import type { AIFieldDefinition } from "@/types/deep-research-reports";

export interface AIFieldsState {
  byId: Record<string, AIFieldDefinition>;
  hydrate: (payload: AIFieldDefinition[]) => void;
  updateOne: (aiFieldId: string, payload: AIFieldDefinition) => void;
  deleteById: (aiFieldId: string) => void;
}

export const useAIFieldsStore = create<AIFieldsState>((set) => ({
  byId: {},

  hydrate: (payload: AIFieldDefinition[]): void => {
    set(
      produce((draft: WritableDraft<AIFieldsState>) => {
        const byId: Record<string, AIFieldDefinition> = {};
        for (let i = 0; i < payload.length; i++) {
          const field = payload[i];
          byId[field.id] = field;
        }
        draft.byId = byId;
      }),
    );
  },

  updateOne: (aiFieldId: string, payload: AIFieldDefinition): void => {
    set(
      produce((draft: WritableDraft<AIFieldsState>) => {
        draft.byId[aiFieldId] = payload;
      }),
    );
  },

  deleteById: (aiFieldId: string): void => {
    set(
      produce((draft: WritableDraft<AIFieldsState>) => {
        delete draft.byId[aiFieldId];
      }),
    );
  },
}));
